import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../style/ReplyRaiseTicket.css";
import { apiAxios } from "../../../../utils/apiAxios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";



const API_BASE = process.env.REACT_APP_API_BASE_URL;
const API_PATH = process.env.REACT_APP_API_PATH_URL;
const APITicket = `${API_BASE}/Ticket`;
const APIDentistCase = `${API_BASE}/Dentist`;
const ReplyRaiseTicket = () => {
  const fileRef = useRef<HTMLInputElement | null>(null);
  const chatEndRef = useRef<any>(null);

  const [selectedTicketId, setSelectedTicketId] = useState<number | null>(null);
  const [replies, setReplies] = useState<any[]>([]);
  const [form, setForm] = useState({
    message: "",
    file: null as File | null,
  });

  const [caseInfo, setCaseInfo] = useState<any>(null);
  const [toothList, setToothList] = useState<any[]>([]);
  const [showCaseModal, setShowCaseModal] = useState(false);

  const [tickets, setTickets] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isQueryFromHub, setIsQueryFromHub] = useState(false);

  const [isTyping, setIsTyping] = useState(false);
  // 🔹 Load Tickets
  const loadTickets = async () => {
    try {
      setLoading(true);
      const res = await apiAxios.get(APITicket);

      const formatted = res.data.map((t: any) => ({
        id: t.ticketID,
        ticketNumber: t.ticketNumber,
        caseID: t.caseID,
        status: t.ticketStatus,
      }));

      setTickets(formatted);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTickets();
  }, []);

  // 🔹 Load Replies
  const loadReplies = async (ticketId: number) => {
    try {
      const res = await apiAxios.get(`${APITicket}/${ticketId}/messages`);

      const formatted = res.data.map((item: any) => ({
        id: item.messageID,
        message: item.message,
        file: item.attachmentPath,
        date: new Date(item.createdDate).toLocaleString("en-GB"),
        senderType: item.senderType,
      }));

      setReplies(formatted);
    } catch (err) {
      console.error(err);
    }
  };
  const [SelectedTicketNumber, setSelectedTicketNumber] = useState<string>("");

  // 🔹 Select Ticket
  // const handleViewReplies = async (ticket: any) => {
  //   setSelectedTicketId(ticket.id);
  //   setSelectedTicketNumber(ticket.ticketNumber);
  //   await loadReplies(ticket.id);
  // };

  const handleViewReplies = async (ticket: any) => {
    setSelectedTicketId(ticket.id);
    setSelectedTicketNumber(ticket.ticketNumber);

    // ✅ RESET FORM HERE
    setForm({
      message: "",
      file: null
    });

    // ✅ CLEAR FILE INPUT
    if (fileRef.current) {
      fileRef.current.value = "";
    }

    await loadReplies(ticket.id);
  };
  // 🔹 Input Change
  const handleChange = (e: any) => {
    setForm({ ...form, message: e.target.value });
  };

  const handleFile = (e: any) => {
    setForm({ ...form, file: e.target.files[0] });
  };

  // 🔹 Send Reply
  const handleSubmit = async () => {
    //if (!form.message.trim()) return;
    if (!form.message.trim() && !form.file) return;
    try {
      const formData = new FormData();
      formData.append("TicketID", selectedTicketId!.toString());
      formData.append("Message", form.message);
      formData.append("IsQueryFromHub", isQueryFromHub.toString());

      if (form.file) {
        formData.append("file", form.file);
      }

      await apiAxios.post(`${APITicket}/admin/reply`, formData);

      toast.success("Reply sent");

      setForm({ message: "", file: null });
      if (fileRef.current) fileRef.current.value = "";

      await loadReplies(selectedTicketId!);
    } catch (err) {
      console.error(err);
      toast.error("Failed to send reply");
    }
  };



  const openCaseDetail = async (caseId: number) => {
    try {
      const res = await apiAxios.post(`${APIDentistCase}/GetReuploadScanDetail`, { CaseID: caseId });

      const data = res.data.singleData || res.data; // ✅ Adjust based on API response
     console.log("Case Detail Response", data);
      if (!data || data.length === 0) return;

      // ✅ First item = case info
      setCaseInfo(data[0]);

      // ✅ Full list = tooth details
      setToothList(data);

      setShowCaseModal(true);

    } catch (err) {
      console.error(err);
      toast.error("Failed to load case");
    }
  };
  const handleCloseTicket = async () => {
    if (!selectedTicketId) return;

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to close this ticket!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, close it!",
      cancelButtonText: "Cancel"
    });

    if (!result.isConfirmed) return;

    try {
      await apiAxios.post(`${APITicket}/${selectedTicketId}/close`, {
        id: selectedTicketId,
      });

      await Swal.fire({
        title: "Closed!",
        text: "Ticket has been closed successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
        customClass: {
          popup: "my-popuprrt",
          title: "my-titlesla",
          htmlContainer: "my-textsla",
          confirmButton: "my-confirm-btnsla btn py-2 px-3  btn-primary btn-primary",
        },


      });

      // refresh list
      await loadTickets();

      // reset UI
      setSelectedTicketId(null);
      setReplies([]);

    } catch (err) {
      console.error(err);

      Swal.fire({
        title: "Error!",
        text: "Failed to close ticket.",
        icon: "error"
      });
    }
  };

  const formatDateTime = (dateString: string) => {
    if (!dateString) return "-";

    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true
    });
  };
  // const handleCloseTicket = async () => {
  //   if (!selectedTicketId) return;

  //   if (!window.confirm("Are you sure you want to close this ticket?")) return;

  //   try {
  //     await apiAxios.post(`${APITicket}/${selectedTicketId}/close`, {
  //       id: selectedTicketId,
  //     });

  //     toast.success("Ticket closed successfully");

  //     // refresh list
  //     await loadTickets();

  //     // reset UI
  //     setSelectedTicketId(null);
  //     setReplies([]);

  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to close ticket");
  //   }
  // };

  // 🔹 Auto Scroll
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [replies]);

  return (
    <div className="container-fluid mt-3 reply-ticket-page">
      <div className="row">


        <div className="col-md-5">
          <div className="premium-card chat-card shadow-sm">
            <div className="card-header">Tickets</div>

            <DataTable
            
              columns={[
                {
                  name: "Ticket",
                  minWidth: "160px",
                  cell: (row: any) => (
                    
                    <div
                     data-tag="allowRowEvents"
                      title={row.ticketNumber}>
                      {row.ticketNumber}
                    </div>
                  ),

                },
                {
                  name: "Status",
                  cell: (row: any) => (
                    <span
                     data-tag="allowRowEvents"
                      title={row.status}
                      className={`badge raise-ticket-badge ${row.status === "Closed" ? "bg-danger" : "bg-success"
                        }`}
                      style={{
                        display: "inline-block",
                        maxWidth: "140px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {row.status}
                    </span>
                  ),
                  minWidth: "160px",
                },
                {
                  name: "Case",
                  cell: (row: any) => (
                    <span
                     data-tag="allowRowEvents"
                      style={{ color: "#0d6efd", cursor: "pointer", fontWeight: 500 }}
                     onClick={(e) => {
                     e.stopPropagation();
                     openCaseDetail(row.caseID);
                     }}
                    >
                      TZ{row.caseID}
                    </span>
                  )
                },
              ]}
              data={tickets}
              progressPending={loading}
              onRowClicked={(row) => {
    console.log("Row Clicked", row);
    handleViewReplies(row);
  }}
              paginationComponentOptions={{
                noRowsPerPage: true
              }}
              pagination
              fixedHeader
              fixedHeaderScrollHeight="400px"
            />
          </div>
        </div>


        <div className="col-md-7">
          <div className="chat-container premium-card raise-ticket-premium-card chat-card">

            {/* Header */}
            <div className="chat-header d-flex justify-content-between align-items-center">
              <span>
                {selectedTicketId
                  ? `Ticket - ${SelectedTicketNumber}`
                  : "Select a ticket"}
              </span>

              {selectedTicketId &&
                !tickets.find(t => t.id === selectedTicketId)?.status?.includes("Closed") && (
                  <button
                    className="btn btn-sm btn-light text-danger"
                    onClick={handleCloseTicket}
                  >
                    Close
                  </button>
                )}
            </div>

            {/* Chat Body */}
            <div className="chat-body">

              {replies.length === 0 && (
                <div className="text-center text-muted mt-3">
                  No messages
                </div>
              )}

              {replies.map((msg) => {
                const hasMessage = msg.message?.trim();
                const hasFile = msg.file && msg.file !== "";

                // 🚀 THIS LINE FIXES YOUR ISSUE
                if (!hasMessage && !hasFile) return null;
                const isSent = msg.senderType === "Central Hub";
                const isUnread = !msg.seen && !isSent;

                return (
                  <div
                    key={msg.id}
                    className={`chat-message ${isSent ? "sent" : "received"} ${isUnread ? "unread" : ""}`}
                  >

                    {/* 🔴 Unread Dot */}


                    <div className="chat-bubble">

                      <div>{msg.message}</div>

                      {/* FILE / IMAGE */}
                      {msg.file && (
                        msg.file.match(/\.(jpeg|jpg|png|gif)$/) ? (
                          <img
                            src={`${API_PATH}${msg.file}`}
                            alt="img"
                            className="chat-img"
                          />
                        ) : (
                          <a
                            href={`${API_PATH}${msg.file}`}
                            target="_blank"
                            rel="noreferrer"
                            className="chat-file"
                          >
                            📎 File
                          </a>
                        )
                      )}

                      {/* TIME + TICK */}
                      <div className="chat-meta">

                        <span className="chat-time-hover">
                          {msg.date}
                        </span>

                        {/* ✔✔ Tick only for sent */}
                        {isSent && (
                          <span
                            className={`tick ${msg.seen ? "seen" : msg.delivered ? "delivered" : ""
                              }`}
                          >
                            ✔✔
                          </span>
                        )}

                      </div>

                    </div>
                  </div>
                );
              })}

              {/* 🔥 Typing Animation */}
              {isTyping && (
                <div className="chat-message received">
                  <div className="chat-bubble typing">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              )}

              <div ref={chatEndRef}></div>
            </div>

            {/* CLOSED */}
            {selectedTicketId &&
              tickets.find(t => t.id === selectedTicketId)?.status?.includes("Closed") && (
                <div className="chat-closed">
                  🔒 This ticket is closed
                </div>
              )}

            {/* Footer */}
            {selectedTicketId &&
              !tickets.find(t => t.id === selectedTicketId)?.status?.includes("Closed") && (

                <div className="chat-footer">

                  {/* 🔥 Ask Input (अब सही जगह पर) */}
                  <div className="chat-top-bar">
                    <label className="chat-checkbox-label">
                      <input
                        type="checkbox"
                        checked={isQueryFromHub}
                        onChange={(e) => setIsQueryFromHub(e.target.checked)}
                      />
                      <span>Ask input from Dentist</span>
                    </label>
                  </div>

                  {/* INPUT ROW */}
                  {/* INPUT ROW */}
                  <div className="chat-input-row">

                    {/* TEXT INPUT */}
                    <div className="chat-input-wrapper position-relative">
                      <input
                        type="text"
                        className="form-control chat-input"
                        placeholder="Type a message..."
                        value={form.message}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && form.message.trim()) {
                            e.preventDefault();
                            handleSubmit();
                          }
                        }}
                      />
                    </div>

                    {/* ✅ FILE INPUT (MISSING BEFORE) */}
                    <input
                      type="file"
                      ref={fileRef}
                      hidden
                      id="fileInput"
                      onChange={handleFile}
                    />

                    {/* FILE ICON */}
                    <label htmlFor="fileInput" className="icon-btn">
                      <i className="bi bi-paperclip"></i>
                    </label>

                    {/* SEND */}
                    <button className="send-btn" onClick={handleSubmit}>
                      <i className="bi bi-send-fill"></i>
                    </button>

                  </div>

                  {/* File Preview */}
                  {form.file && (
                    <div className="file-preview">

                      {form.file.type.startsWith("image/") ? (
                        <img
                          src={URL.createObjectURL(form.file)}
                          alt="preview"
                          className="preview-img"
                        />
                      ) : (
                        <span>📎 {form.file.name}</span>
                      )}

                      <i
                        className="bi bi-x-circle-fill remove-file"
                        onClick={() =>
                          setForm(prev => ({ ...prev, file: null }))
                        }
                      ></i>
                    </div>
                  )}

                </div>
              )}

          </div>
        </div>

      </div>
      {showCaseModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">

            <div className="modal-header">
              <h5>Case Details</h5>

              <button onClick={() => setShowCaseModal(false)} className="custom-close-btn raise-ticket-closebtn btn-close "><i className="bi bi-x customcross"></i></button>
            </div>

            <div className="modal-body">

              {/* 🔹 CASE INFO */}
              {caseInfo && (
                <div className="mb-3 border-bottom pb-2">
                  <div className="carse-id-text"><strong>Case ID:</strong> TZ{caseInfo.caseID}</div>
                  {/* <div className="carse-id-text"><strong>Order ID:</strong> {caseInfo.orderID}</div> */}
                  <div className="carse-id-text"><strong>Patient:</strong> {caseInfo.patientName}</div>
                  <div className="carse-id-text">
                    <strong>Status:</strong>
                    <span className="badge bg-warning ms-2">
                      {caseInfo.dentistTag}
                    </span>
                  </div >
                  <div className="carse-id-text">
                    <strong>ETA:</strong> {formatDateTime(caseInfo.expectedEta)}
                  </div>
                </div>
              )}

              {/* 🔹 TOOTH TABLE */}
              <div>
                <h6>Tooth Details</h6>

                <table className="table table-bordered table-sm">
                  <thead className="table-light">
                    <tr>
                      <th>Tooth No</th>
                      <th>Shade</th>
                      <th>Material</th>
                    </tr>
                  </thead>
                  <tbody>
                    {toothList.map((t, i) => (
                      <tr key={i}>
                        <td>{t.toothNumber}</td>
                        <td>{t.shade}</td>
                        <td>{t.materialName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReplyRaiseTicket;